<template>
    <section class="step-4" :class="{ 'recap-cruise': !loading }">

        <template v-if="!loading">

            <div class="head">
                <h2 class="titre-produit">Récapitulatif</h2>
            </div>
            <p class="trip-dates">Voyage du {{ form.tripDates.label }}</p>
            <article class="un-produit">
                <div class="une-cabine" v-for="cabin in form.cabins">
                    <h3 class="nom-cabine">{{ cabin.type.label }} <span
                            class="col-right price big blue">{{getTotalCabinPrice(cabin) | currency}}</span>
                    </h3>
                    <div class="un-voyageur" v-for="(traveler, index) in cabin.travelers">
                        <p class="nom"><img
                                src="/app/themes/grands-espaces/assets/images/page-produit/travelers/traveler_1.svg"
                                alt="">
                            Voyageur {{ index + 1 }} : <span>{{ traveler.firstName }} {{ traveler.lastName }}</span></p>

                        <p v-if="traveler.addons.length" v-for="addonId in traveler.addons" class="extension-option">
                            {{getAddonLabel(addonId)}} <span class="col-right price">{{getAddonPrice(addonId) | currency}}</span>
                        </p>

                        <p v-if="traveler.options.length" v-for="optionId in traveler.options" class="extension-option">
                            {{getOptionLabel(optionId)}} <span class="col-right price">{{getOptionPrice(optionId) | currency}}</span>
                        </p>

                        <p v-if="traveler.geneve !== null" class="extension-option">
                            Départ depuis Genève ({{getGeneveLabel(traveler.geneve)}})<span class="col-right price">{{getGenevePrice(traveler.geneve) | currency}}</span>
                        </p>

                        <p v-if="traveler.insurance !== null" class="extension-option">
                            {{getInsuranceLabel(traveler.insurance)}}<span class="col-right price">{{getInsurancePrice(traveler.insurance)}} %</span>
                        </p>

                        <p class="infos-voyageurs">Email : {{ traveler.email }}</p>
                        <p class="infos-voyageurs">Date de naissance : {{ getDate(traveler.birthDate) | date(format)
                            }}</p>
                        <p class="infos-voyageurs" v-if="traveler.passportId">N° de passeport : {{ traveler.passportId
                            }}</p>
                        <p class="infos-voyageurs" v-if="traveler.passportValidityDate">Date de validité : {{
                            getDate(traveler.passportValidityDate) | date(format)
                            }}</p>
                    </div>
                </div>
            </article>
            <article v-if="showInsuranceAlert" class="consent_assurance">
                <div class="choix">
                    <input type="checkbox"
                           class="ge"
                           id="consent_assurance"
                           v-model="consent_assurance"
                           required>
                    <label for="consent_assurance">
                        <p>Les caractéristiques essentielles du contrat d’assurance sont décrites dans le <a :href="assurance_dip" target="_blank">Document
                            D’Information Produit</a> et les <a :href="assurance_cgv" target="_blank">Conditions Générales d’Assurance</a> dont vous avez pris connaissance
                            avec vos documents de voyage. En cochant cette case, vous les acceptez sans réserve.</p>
                    </label>
                </div>
            </article>

            <div class="total">
                <p>Total de votre commande : <span class="col-right align-right price blue verybig">{{getTotalOrder | currency}}</span>
                </p>
            </div>


        </template>


        <div class="cta">
            <div class="loader-spin" v-if="loading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>

            <button type="button" @click="submitCTA('option')" class="btn gtm-add-option" v-if="!loading">
                Poser une option
            </button>

            <button type="button" @click="submitCTA('submit')" class="btn chevron gtm-add-product" v-if="!loading">
                Réserver maintenant
            </button>
            <v-dialog/>
        </div>
    </section>
</template>

<script>
    import {DateTime} from 'luxon';
    import {findIndex, forEach} from 'lodash';

    export default {
        props: {
            loading: {
                type: Boolean,
                required: true,
            },
            form: {
                type: Object,
                required: true,
            },
            cruise: {
                type: Object,
                required: true,
            },
            selectedDateIndex: {
                type: Number,
                required: true,
            },
        },
        data: () => ({
            format: {month: 'long', day: 'numeric', year: 'numeric'},
            consent_assurance: false
        }),
        computed: {
            getTotalOrder() {
                let totalAmount = 0;

                forEach(this.form.cabins, (cabin, index) => {

                        forEach(cabin.travelers, (traveler, index) => {

                                // Prix cabine
                                let cabinPrice = cabin.book_all ? cabin.price * 1.8 : cabin.price;

                                // Addons
                                let thisTravelerTotalAddonsPrice = 0;
                                if (traveler.addons.length) {
                                    forEach(traveler.addons, (addon, index) => {
                                        thisTravelerTotalAddonsPrice += this.getAddonPrice(addon);
                                    });
                                }

                                // Options
                                let thisTravelerTotalOptionPrice = 0;
                                if (traveler.options.length) {
                                    forEach(traveler.options, (option, index) => {
                                        thisTravelerTotalOptionPrice += this.getOptionPrice(option);
                                    });
                                }

                                // Geneve
                                let thisTravelerGenevePrice = 0;
                                if (this.cruise.dates[this.selectedDateIndex].option_geneve && traveler.geneve !== null) {
                                    thisTravelerGenevePrice = this.getGenevePrice(traveler.geneve);
                                }

                                // Insurance
                                let thisTravelerInsurancePrice = 0;
                                if (traveler.insurance !== null) {
                                    thisTravelerInsurancePrice = (this.getInsurancePrice(traveler.insurance) / 100) * (cabinPrice + thisTravelerTotalAddonsPrice + thisTravelerTotalOptionPrice + thisTravelerGenevePrice);
                                }

                                totalAmount += cabinPrice + thisTravelerTotalAddonsPrice + thisTravelerTotalOptionPrice + thisTravelerGenevePrice + thisTravelerInsurancePrice;

                            }
                        );
                    }
                );


                return Math.round(totalAmount);
            },
            showInsuranceAlert() {
                var show = false;

                this.form.cabins.forEach((cabin) => {
                    cabin.travelers.forEach((traveler) => {
                        if (traveler.insurance !== null) {
                            show = true
                        }

                    });
                });
                return show
            },
            assurance_dip(){
                return window.GrandsEspaces.assurance_dip
            },
            assurance_cgv(){
                return window.GrandsEspaces.assurance_cgv
            }
        },
        methods: {
            getDate(date) {
                return DateTime.fromFormat(date, "dd/MM/yyyy");
            },
            getAddonLabel(addonID) {
                return this.cruise.dates[this.selectedDateIndex].addons[this.getAddonIndex(addonID)].label;
            },
            getAddonPrice(addonID) {
                return this.cruise.dates[this.selectedDateIndex].addons[this.getAddonIndex(addonID)].price;
            },
            getInsuranceLabel(insuranceID) {
                return this.cruise.dates[this.selectedDateIndex].insurances[this.getInsuranceIndex(insuranceID)].label;
            },
            getInsurancePrice(insuranceID) {
                return this.cruise.dates[this.selectedDateIndex].insurances[this.getInsuranceIndex(insuranceID)].price;
            },
            getOptionLabel(optionID) {
                return this.cruise.dates[this.selectedDateIndex].options[this.getOptionIndex(optionID)].label;
            },
            getOptionPrice(optionID) {
                return this.cruise.dates[this.selectedDateIndex].options[this.getOptionIndex(optionID)].price;
            },
            getAddonIndex(addonID) {
                return findIndex(this.cruise.dates[this.selectedDateIndex].addons, addon => {
                    return addonID === addon.id;
                });
            },
            getInsuranceIndex(insuranceID) {
                return findIndex(this.cruise.dates[this.selectedDateIndex].insurances, insurance => {
                    return insuranceID === insurance.id;
                });
            },
            getGenevePrice(formule) {

                if (formule === "solo") {
                    return this.cruise.dates[this.selectedDateIndex].option_geneve_solo_price;
                } else {
                    return this.cruise.dates[this.selectedDateIndex].option_geneve_duo_price;
                }

            },
            getGeneveLabel(val) {
                return val === "solo" ? 'individuel' : 'double';
            },
            getOptionIndex(optionID) {
                return findIndex(this.cruise.dates[this.selectedDateIndex].options, option => {
                    return optionID === option.id;
                });
            },
            getTotalCabinPrice(cabin) {
                return cabin.book_all ? cabin.price * 1.8 : cabin.price * cabin.seats;
            },
            submitCTA(action) {

                if (this.showInsuranceAlert && !this.consent_assurance) {
                    // alert('Vous devez cocher les caractéristiques essentielles du contrat d\'assurance avant de continuer')
                    this.$modal.show('dialog', {
                        text: `Vous devez cocher les caractéristiques essentielles du contrat d'assurance avant de continuer.`,
                        buttons: [
                            {
                                title: 'Retour'
                            }
                        ]
                    });
                    return
                }

                if (action === 'option') {
                    this.$emit('option')
                } else {
                    this.$emit('submit')
                }

            },
            mounted(){
                console.log(this.$modal)
            }
        },
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/cruise-configurator/CruiseComplete.vue